import { type AuthUser } from "wasp/auth";
import DefaultLayout from "../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../useRedirectHomeUnlessUserIsAdmin";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PaymentPlanId, prettyPaymentPlanName } from "../../payment/plans";
import {
  useQuery,
  createPortal,
  getOrCreateCustomer,
  getCustomer,
} from "wasp/client/operations";
import chargebee from "chargebee";

interface Tab {
  id: string;
  displayName: string;
}

const AdminBillingPage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });
  const [fetchCustomer, setFetchCustomer] = useState(false);

  const {
    data: portal,
    isLoading: isLoadingPortal,
    error: portalError,
  } = useQuery(createPortal, { customerEmail: user.email });
  const {
    data: customer,
    isLoading: isLoadingCustomer,
    error: customerError,
  } = useQuery(getCustomer, { email: user.email });

  /*   const {
    data: getOrCreate,
    isLoading: isLoadingGOC,
    error: GOCError,
  } = useQuery(getOrCreateCustomer, { email: user.email }); */
  const {
    data: getOrCreate,
    isLoading: isLoadingGOC,
    error: GOCError,
  } = useQuery(
    getOrCreateCustomer,
    { email: user.email },
    {
      enabled: fetchCustomer, // Sorgu sadece fetchCustomer true olduğunda çalışır
    }
  );

  /*  function openCustomerPortal(id) {
    chargebee.portal
      .open({
        customer_id: id, // Buraya müşteri ID'sini koyun
      })
      .then(function (response) {
        console.log("Customer Portal closed");
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
  } */

  useEffect(() => {
    if (portal && portal !== "No customer found with the provided email.") {
      const portalFrame = document.getElementById(
        "portal"
      ) as HTMLIFrameElement;
      portalFrame.src = (portal as any).portal_session.access_url;
    } else {
      setFetchCustomer(true);
    }
  }, [portal]);

  const [selectedTab, setSelectedTab] = useState("billing_email");

  /* useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.chargebee.com/v2/chargebee.js";
    script.setAttribute("data-cb-site", "marketplaceiq");
    script.async = true;
    script.onload = () => {
      console.log("Chargebee script loaded successfully");
      window.Chargebee.init({
        site: "marketplaceiq",
      });
    };
    script.onerror = (error) => {
      console.error("Error loading Chargebee script", error);
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.Chargebee.init({
        site: "marketplaceiq",
      });
      const portalButton = document.getElementById("portal");
      console.log(portalButton);
      portalButton?.click();
    }, 1000);
  }, []); */

  return (
    <DefaultLayout user={user}>
      {/* <div className="bg-[#f9fafb] h-full absolute top-0 left-0 px-0 py-10 dark:bg-[#050608] w-full">
        <div className="container bg-[#f9fafb] mx-auto max-w-7xl px-6 lg:px-8 font-satoshi">
          <div className="bg-[#f9fafb] flex items-center justify-start">
            <div className="relative bg-[#f9fafb] flex w-fit gap-3 px-0.5 py-0.5">
              {tabs.map((tab: Tab) => (
                <button
                  id={tab.id}
                  onClick={() => {
                    setSelectedTab(tab.id);
                  }}
                  className={`${
                    selectedTab === tab.id
                      ? "bg-white text-black dark:bg-[#1e1f21]"
                      : "text-gray-500 dark:text-white dark:bg-black"
                  } w-fit py-2 px-4 rounded-xl text-center font-semibold transition-all duration-300 border border-gray-300 hover:bg-white hover:text-black dark:border-none dark:hover:bg-[#1e1f21]`}
                >
                  {tab.displayName}
                </button>
              ))}
            </div>
          </div>
          <div className="flex flex-col mt-10 px-5 border border-1 border-[#d0d5dd] min-h-[200px] bg-white rounded-lg py-5">
            {selectedTab === "billing_email" && (
              <>
                <h2 className="text-xl font-semibold mb-1">Billing email</h2>
                <p className="text-sm text-gray-600 ">
                  All generated invoices will be sent to this email address in
                  pdf format.
                </p>

                <hr className="my-6 border-gray-300" />
                <form>
                  <div className="grid grid-cols-3">
                    <label
                      htmlFor="company"
                      className="block text-sm font-semibold text-gray-700"
                    >
                      Billing email
                    </label>
                    <input
                      type="text"
                      id="billing_email"
                      placeholder="Billing email"
                      className="col-span-2 mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </form>
              </>
            )}
            {selectedTab === "billing_address" && (
              <>
                <h2 className="text-xl font-semibold mb-1">Billing Address</h2>
                <p className="text-sm text-gray-600 mb-1">
                  Update your billing address.
                </p>
                <hr className="my-6 border-gray-300" />
                <button className="w-fit bg-black text-white px-5 py-4 rounded-md font-semibold">
                  Uptade billing address
                </button>
              </>
            )}
            {selectedTab === "invoices" && (
              <>
                <h2 className="text-xl font-semibold mb-1">
                  Pay unpaid invoices
                </h2>
                <p className="text-sm text-gray-600 mb-1">
                  You have 0 unpaid invoice.
                </p>
                <hr className="my-6 border-gray-300" />
                <h2 className="text-xl font-semibold mb-1">Download</h2>
                <p className="text-sm text-gray-600 mb-1">
                  Download past invoices in pdf format.
                </p>
                <hr className="my-6 border-gray-300" />
                <button className="w-fit bg-black text-white px-5 py-4 rounded-md font-semibold">
                  Download invoices
                </button>
              </>
            )}
            {selectedTab === "cancel_subscription" && (
              <>
                <h2 className="text-xl font-semibold mb-1">
                  Cancel your subscription
                </h2>
                <p className="text-sm text-gray-600 mb-1 flex">
                  If you cancel your subscription you will be able to use your
                  credit until:
                  <p className="text-sm font-semibold ml-1">
                    07 December 2024.
                  </p>
                </p>
                <hr className="my-6 border-gray-300" />
                <button className="w-fit bg-black text-white px-5 py-4 rounded-md font-semibold">
                  Cancel subscription
                </button>
              </>
            )}
          </div>
        </div>
      </div> */}
      {/* <a href="javascript:void(0)" data-cb-type="portal" id="portal">
        Manage account
      </a> */}
      <iframe
        id="portal"
        src="https://marketplaceiq.chargebeeportal.com?layout=in_app"
        style={{
          width: "100%",
          height: "85vh",
        }}
      />
    </DefaultLayout>
  );
};

export default AdminBillingPage;
